import { Autocomplete, TextField } from '@mui/material';
import styles from './SearchFilter.module.scss';
import Dropdown from '../../../core/Dropdown';
import CheckboxGroup from '../../../core/CheckboxGroup';
import { FilterOptions } from '../../../../libs/types';
import { convertUserOptions, createBillingOptions } from '../../../../libs/helpers';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../apis/store';
import { debounce } from '../../../../libs/debouce';
import { cutoffDate, InvStatus } from '../../../../libs/constants';


export const SearchFilter = (props: SearchFilterProps) => {
  const optionState = useSelector((state: RootState) => state.options);
  const {filterOptions, onChangeFilter} = props;


    const handleCheckbox = (checked: boolean, currentItem: string) => {
        if (filterOptions.invStatus === undefined) {return}
        let newArr = [...filterOptions.invStatus];
        if (!checked) {
            const currentItemId = newArr.findIndex(item => item === currentItem);
            newArr.splice(currentItemId, 1);
        }
        if (checked) { newArr.push(currentItem)}
        onChangeFilter({...filterOptions, invStatus: newArr})
    }

    const searchInput = debounce((e: any) => onChangeFilter({...filterOptions, brandText: e}))


    return (
        <div className={styles.filters}>
            <div className={styles.filters__content}>
                <div className={styles.filters__content_title}>検索条件</div>
                <div className={styles.filters__content_option1}>
                    <div>
                      <div className={styles.label}>ブランド名 / ブランドNo.</div>
                      <Autocomplete
                          freeSolo
                          options={optionState.brandNameOptions}
                          sx={{ width:"530px" }}
                          renderInput={(params) => <TextField className={styles.brand_name} {...params} />}
                          onInputChange={(event, newInputValue) => searchInput(newInputValue)}
                      />
                    </div>
                    <Dropdown options={convertUserOptions(optionState.userOptions)} 
                        value={filterOptions.contactPerson.toString()}
                        defaultVal={filterOptions.contactPerson.toString()}
                        onChange={(val) => onChangeFilter({...filterOptions, contactPerson: val})} 
                        label="担当者名" labelStyle={styles.label}/>
                </div>
                <div className={styles.filters__content_option2}>
                    <Dropdown options={createBillingOptions()} value={filterOptions.month} onChange={(val) => onChangeFilter({...filterOptions, month: val})} label="請求月"/>
                    <Dropdown options={cutoffDate} value={filterOptions.day} onChange={(val) => onChangeFilter({...filterOptions, day: val})} label="請求締日"/>
                    <div>
                        <div className={styles.checbox_group}>
                            <div>請求ステータス</div>
                            <div>
                                <CheckboxGroup checked={filterOptions.invStatus.includes(InvStatus.NOT_CONFIRMED)} onChange={(val) => handleCheckbox(val, InvStatus.NOT_CONFIRMED)} label="未確定"/>
                                <CheckboxGroup checked={filterOptions.invStatus.includes(InvStatus.CONFIRMED)} onChange={(val) => handleCheckbox(val, InvStatus.CONFIRMED)} label="確定済"/>
                                <CheckboxGroup checked={filterOptions.invStatus.includes(InvStatus.EXPORT)} onChange={(val) => handleCheckbox(val, InvStatus.EXPORT)} label="請求書発行済"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export type SearchFilterProps = {
    filterOptions: FilterOptions;
    onChangeFilter: (val: FilterOptions) => void;
}